'use client';

import { useRouter } from 'next/navigation';
import { ReactElement, useEffect } from 'react';
import LoadingIndicator from './components/loadingIndicator';
import { useAppSelector } from './redux';
export default function IndexPage(): ReactElement {
  const router = useRouter();
  const authState: IAuthState = useAppSelector(state => state.auth);
  useEffect(() => {
    if (authState.isAuth && authState.user && !authState.user.Suspended) {
      if (authState.user?.MFAMandatory && !authState.isMFAVerified) {
        if (authState.user?.AuthenticatorSet) {
          router.push('/mfaLogin');
        } else {
          router.push('/mfa');
        }
      } else {
        router.push('/overview');
      }
    } else {
      router.push('/login');
    }
  }, [authState, router]);
  if (authState.isLoggingIn) {
    return <LoadingIndicator />;
  }
  return <></>;
}